/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CourtSummary } from './CourtSummary';
import {
    CourtSummaryFromJSON,
    CourtSummaryFromJSONTyped,
    CourtSummaryToJSON,
    CourtSummaryToJSONTyped,
} from './CourtSummary';
import type { CategorySummary } from './CategorySummary';
import {
    CategorySummaryFromJSON,
    CategorySummaryFromJSONTyped,
    CategorySummaryToJSON,
    CategorySummaryToJSONTyped,
} from './CategorySummary';
import type { TeamBasic } from './TeamBasic';
import {
    TeamBasicFromJSON,
    TeamBasicFromJSONTyped,
    TeamBasicToJSON,
    TeamBasicToJSONTyped,
} from './TeamBasic';
import type { ResourcePermissionsResponse } from './ResourcePermissionsResponse';
import {
    ResourcePermissionsResponseFromJSON,
    ResourcePermissionsResponseFromJSONTyped,
    ResourcePermissionsResponseToJSON,
    ResourcePermissionsResponseToJSONTyped,
} from './ResourcePermissionsResponse';

/**
 * 
 * @export
 * @interface MatchSummary
 */
export interface MatchSummary {
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    tournamentId?: string;
    /**
     * 
     * @type {TeamBasic}
     * @memberof MatchSummary
     */
    teamA?: TeamBasic;
    /**
     * 
     * @type {TeamBasic}
     * @memberof MatchSummary
     */
    teamB?: TeamBasic;
    /**
     * 
     * @type {CategorySummary}
     * @memberof MatchSummary
     */
    category?: CategorySummary;
    /**
     * 
     * @type {Date}
     * @memberof MatchSummary
     */
    matchTime?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MatchSummary
     */
    teamAScore?: number;
    /**
     * 
     * @type {number}
     * @memberof MatchSummary
     */
    teamBScore?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    winnerTeamId?: string;
    /**
     * 
     * @type {CourtSummary}
     * @memberof MatchSummary
     */
    court?: CourtSummary;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    groupName?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    stageName?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    label?: string;
    /**
     * 
     * @type {number}
     * @memberof MatchSummary
     */
    roundNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof MatchSummary
     */
    streamingUrl?: string | null;
    /**
     * 
     * @type {ResourcePermissionsResponse}
     * @memberof MatchSummary
     */
    permissions?: ResourcePermissionsResponse;
}

/**
 * Check if a given object implements the MatchSummary interface.
 */
export function instanceOfMatchSummary(value: object): value is MatchSummary {
    return true;
}

export function MatchSummaryFromJSON(json: any): MatchSummary {
    return MatchSummaryFromJSONTyped(json, false);
}

export function MatchSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tournamentId': json['tournamentId'] == null ? undefined : json['tournamentId'],
        'teamA': json['teamA'] == null ? undefined : TeamBasicFromJSON(json['teamA']),
        'teamB': json['teamB'] == null ? undefined : TeamBasicFromJSON(json['teamB']),
        'category': json['category'] == null ? undefined : CategorySummaryFromJSON(json['category']),
        'matchTime': json['matchTime'] == null ? undefined : (new Date(json['matchTime'])),
        'teamAScore': json['teamAScore'] == null ? undefined : json['teamAScore'],
        'teamBScore': json['teamBScore'] == null ? undefined : json['teamBScore'],
        'status': json['status'] == null ? undefined : json['status'],
        'winnerTeamId': json['winnerTeamId'] == null ? undefined : json['winnerTeamId'],
        'court': json['court'] == null ? undefined : CourtSummaryFromJSON(json['court']),
        'groupName': json['groupName'] == null ? undefined : json['groupName'],
        'stageName': json['stageName'] == null ? undefined : json['stageName'],
        'label': json['label'] == null ? undefined : json['label'],
        'roundNumber': json['roundNumber'] == null ? undefined : json['roundNumber'],
        'streamingUrl': json['streamingUrl'] == null ? undefined : json['streamingUrl'],
        'permissions': json['permissions'] == null ? undefined : ResourcePermissionsResponseFromJSON(json['permissions']),
    };
}

export function MatchSummaryToJSON(json: any): MatchSummary {
    return MatchSummaryToJSONTyped(json, false);
}

export function MatchSummaryToJSONTyped(value?: MatchSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tournamentId': value['tournamentId'],
        'teamA': TeamBasicToJSON(value['teamA']),
        'teamB': TeamBasicToJSON(value['teamB']),
        'category': CategorySummaryToJSON(value['category']),
        'matchTime': value['matchTime'] == null ? value['matchTime'] : value['matchTime'].toISOString(),
        'teamAScore': value['teamAScore'],
        'teamBScore': value['teamBScore'],
        'status': value['status'],
        'winnerTeamId': value['winnerTeamId'],
        'court': CourtSummaryToJSON(value['court']),
        'groupName': value['groupName'],
        'stageName': value['stageName'],
        'label': value['label'],
        'roundNumber': value['roundNumber'],
        'streamingUrl': value['streamingUrl'],
        'permissions': ResourcePermissionsResponseToJSON(value['permissions']),
    };
}

